















import { Component, Prop, Vue } from 'vue-property-decorator';
import { departmentTypes } from '../helper';

@Component({
  inheritAttrs: false
})
export default class DepartmentTypeSelect extends Vue {
  @Prop({ type: [Array, String] }) value!: string | string[];
  @Prop({ type: Boolean, default: true }) required!: boolean;
  @Prop({ type: Boolean, default: false }) multiple!: boolean;

  get list() {
    return departmentTypes();
  }

  created() {
    this.$emit('input', this.value);
  }
}
